import { render, staticRenderFns } from "./Dictionaries.vue?vue&type=template&id=a116f05e&scoped=true&"
import script from "./Dictionaries.vue?vue&type=script&lang=js&"
export * from "./Dictionaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a116f05e",
  null
  
)

export default component.exports